// lib/maiImage.ts
export class MaiImageInputError extends Error {}

export const MAI_IMAGE_MODELS = {
  'mai-2.5-pro': {
    name: 'MAI 2.5 Pro',
    deployment: 'MAI-Image-2.5-Pro',
    purpose: 'Highest quality in the 2.5 family, with object, character, material and spatial consistency.',
  },
  'mai-2.6-flash': {
    name: 'MAI 2.6 Flash',
    deployment: 'MAI-Image-2.6-Flash',
    purpose: 'Faster, lower-cost 2.6 image generation and editing.',
  },
  'mai-2.6': {
    name: 'MAI 2.6',
    deployment: 'MAI-Image-2.6',
    purpose: 'Latest MAI improvements to text, portraits, 3D imagery and photorealistic commercial output.',
  },
} as const;

export function isNewMaiImageModel(model: string): model is keyof typeof MAI_IMAGE_MODELS {
  return Object.hasOwn(MAI_IMAGE_MODELS, model);
}

export function isMaiModel(model: string): model is 'mai-2.5-flash' | keyof typeof MAI_IMAGE_MODELS {
  return model === 'mai-2.5-flash' || isNewMaiImageModel(model);
}

export function maiDeployment(model: 'mai-2.5-flash' | keyof typeof MAI_IMAGE_MODELS): string {
  return model === 'mai-2.5-flash' ? 'MAI-Image-2.5-Flash' : MAI_IMAGE_MODELS[model].deployment;
}

export function resolveMaiImageDimensions(width: number, height: number): { width: number; height: number } {
  const ratio = width / height;
  const outputWidth = Math.floor(Math.sqrt(1_048_576 * ratio));
  const outputHeight = Math.floor(1_048_576 / outputWidth);
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0
    || outputWidth < 768 || outputHeight < 768 || Math.abs(outputWidth / outputHeight / ratio - 1) > 0.002) {
    throw new MaiImageInputError('MAI requires an image ratio between 9:16 and 16:9 within one megapixel. Choose a supported frame or another model.');
  }
  return { width: outputWidth, height: outputHeight };
}
